/* global registerButtonAsRecaptchaTrigger */
'use strict';

const keyboardAccessibility = require('./keyboardAccessibility');

/**
 * Adds password visibilty icon on each
 * password field and their respective
 * event listeners
 */
function addPasswordVisibility() {
    const $passwordField = $('input[type=password]');

    $passwordField.each(function () {
        const $thisPWField = $(this);

        if (!$thisPWField.siblings('.js-show-password').length) {
            // add toggle icon to the PW field
            const $icon = $('<svg class="js-show-password show-password-icon"><use href="#visibility_on"></use></svg>');

            // Make existing icon keyboard accessible
            $icon.attr({
                tabindex: '0',
                role: 'button',
                'aria-label': $thisPWField.data('show-password-label')
            });

            $thisPWField.after($icon);

            // toggle the PW visibility
            $icon.on('click', function () {
                const currentType = $thisPWField.attr('type');
                $thisPWField.attr('type', currentType === 'password' ? 'text' : 'password');
                $icon.find('use').attr('href', currentType === 'password' ? '#visibility_off' : '#visibility_on');
                $icon.attr(
                    'aria-label',
                    currentType === 'password'
                        ? $thisPWField.data('hide-password-label')
                        : $thisPWField.data('show-password-label')
                );
            });
        }
    });

    // Keyboard accessibility for password visibility icon
    keyboardAccessibility('.js-show-password', {
        13: function () {
            $(this).trigger('click');
            return true;
        },
        32: function () {
            $(this).trigger('click');
            return true;
        }
    },
    function () {
        return this;
    });
}

module.exports = {
    init: function () {
        addPasswordVisibility();

        $(document).on('form:created', function () {
            addPasswordVisibility();
        });
    }
};
